import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Ng2StateDeclaration, UIRouterModule } from '@uirouter/angular';
import { ConferencePageComponent } from './conference-page.component';
import { ConferenceModule } from './conference/conference.module';
import { SkeletonLoaderModule } from 'src/app/shared/skeleton-loader/skeleton-loader.module';

const states: Ng2StateDeclaration[] = [
  {
    name: 'conference',
    url: '/conference?c&j&jm&t&mode&sh&ws&m',
    component: ConferencePageComponent,
    data: {
      requireLogin: true
    },
    params: {
      candidateId: null,
      jobId: null,
      jobMatchId: null
    }
  }
];

@NgModule({
  declarations: [ConferencePageComponent],
  imports: [
    CommonModule,
    ConferenceModule,
    SkeletonLoaderModule,
    UIRouterModule.forChild({ states })
  ],
  entryComponents: [ConferencePageComponent],
})
export class ConferencePageModule { }
